import { createContext } from "react";

export interface SettingsType {
  planData: boolean;
  foreCastData: boolean;
}

interface InitialStateType {
  settingsState: SettingsType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  settingsSetState: any;
}

const SettingsContext = createContext<InitialStateType[]>([]);

export default SettingsContext;
